import { Routes } from '@angular/router';
import { DocketComponent } from './docket.component';

export const docketRoutes: Routes = [
  {
    path: ':docketId',
    component: DocketComponent
  }
];
